import defaultServiceProviderLogo from "../assets/images/default-service-provider-logo.svg";
import goodWeMiniLogo from "../assets/images/good_we_mini_logo.svg";
import growattMiniLogo from "../assets/images/growatt-logo.png";
import powerhubMiniLogo from "../assets/images/powerhub-logo.svg";
import vRMiniLogo from "../assets/images/vrm_mini_logo.svg";
import { ESolarServiceProvider } from "../enums/solar-service-provider";

export const getServiceProviderLogo = (
  serviceProvider: ESolarServiceProvider,
): string => {
  switch (serviceProvider) {
    case ESolarServiceProvider.VRM:
      return vRMiniLogo;
    case ESolarServiceProvider.GOODWE:
      return goodWeMiniLogo;
    case ESolarServiceProvider.GROWATT:
      return growattMiniLogo;
    case ESolarServiceProvider.POWERHUB:
      return powerhubMiniLogo;
    default:
      return defaultServiceProviderLogo;
  }
};
